var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#F15B59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99375 10.0496L5.31875 13.7246C5.18125 13.8621 5.00625 13.9309 4.79375 13.9309C4.58125 13.9309 4.40625 13.8621 4.26875 13.7246C4.13125 13.5871 4.0625 13.4121 4.0625 13.1996C4.0625 12.9871 4.13125 12.8121 4.26875 12.6746L7.94375 8.99961L4.26875 5.32461C4.13125 5.18711 4.0625 5.01211 4.0625 4.79961C4.0625 4.58711 4.13125 4.41211 4.26875 4.27461C4.40625 4.13711 4.58125 4.06836 4.79375 4.06836C5.00625 4.06836 5.18125 4.13711 5.31875 4.27461L8.99375 7.94961L12.6688 4.27461C12.8063 4.13711 12.9812 4.06836 13.1938 4.06836C13.4062 4.06836 13.5813 4.13711 13.7188 4.27461C13.8562 4.41211 13.925 4.58711 13.925 4.79961C13.925 5.01211 13.8562 5.18711 13.7188 5.32461L10.0437 8.99961L13.7188 12.6746C13.8562 12.8121 13.925 12.9871 13.925 13.1996C13.925 13.4121 13.8562 13.5871 13.7188 13.7246C13.5813 13.8621 13.4062 13.9309 13.1938 13.9309C12.9812 13.9309 12.8063 13.8621 12.6688 13.7246L8.99375 10.0496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleIcon);
export default __webpack_public_path__ + "static/media/redCircleIcon.31ee20434e65d8069077ec56e193bf25.svg";
export { ForwardRef as ReactComponent };